import { useEffect } from "react";
import SmoothScroll from "components/landing/SmoothScroll";
import Nav from "components/landing/Nav";
import Hero from "components/landing/Hero";
import Marquee from "components/landing/Marquee";
import Manifesto from "components/landing/Manifesto";
import ConversationSection from "components/landing/ConversationSection";
import CommunityShowcase from "components/landing/CommunityShowcase";
import AudienceSection from "components/landing/AudienceSection";
import CTA from "components/landing/CTA";
import Footer from "components/landing/Footer";
import LegalProvider, { useLegal } from "components/app/LegalModal";

const LandingEffects = ({ terms, communityGuidelines }) => {
  const { openPage } = useLegal() || {};

  useEffect(() => {
    if (terms) openPage?.("terms");
    else if (communityGuidelines) openPage?.("community");
  }, [terms, communityGuidelines, openPage]);

  return null;
};

const Landing = ({ terms = false, communityGuidelines = false }) => {
  return (
    <LegalProvider>
      <SmoothScroll>
        <div className="landing-root relative min-h-screen bg-zinc-950 text-zinc-50 font-sans-body overflow-x-hidden">
          <LandingEffects
            terms={terms}
            communityGuidelines={communityGuidelines}
          />
          <Nav />
          <main>
            <Hero />
            <Marquee />
            <Manifesto />
            <ConversationSection />
            <CommunityShowcase />
            <AudienceSection />
            <CTA />
          </main>
          <Footer />
        </div>
      </SmoothScroll>
    </LegalProvider>
  );
};

export default Landing;
